import { render, staticRenderFns } from "./SelectPixKeyQRCodePixModalSection.vue?vue&type=template&id=c5a64ac8"
import script from "./SelectPixKeyQRCodePixModalSection.vue?vue&type=script&lang=js"
export * from "./SelectPixKeyQRCodePixModalSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports